import React from 'react';
type Props = ISFCRenderProps;
const xss = require('xss');

export interface ISFCRenderProps {
  value?: string;
}

export function SFCRender(props: Props) {
  return (
    <div className="ql-container">
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: xss(props.value || '') }} />
    </div>
  );
}

export default SFCRender;
